import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Linkedin, EnvelopeFill } from "react-bootstrap-icons";
import "./teammember.scss";

function TeamMember() {
  return (
    <section className="team-section">
      <Container className="py-5">

        {/* Section Header */}
        <div className="text-center mb-5">
          <h2 className="section-title">Our Team</h2>
          <p className="section-subtitle">
            Meet the people who drive innovation and success
          </p>
        </div>

        <Row className="g-4">

          {/* Team Member 1 */}
          <Col md={3}>
            <Card className="team-card">
              <img
                src="/images/arvind-kumar.jpeg"
                alt="Team Member"
                className="team-img"
              />
              <Card.Body>
                <h5 className="team-name">Arvind Kumar</h5>
                <p className="team-role">Sales Executive Manager (SEM)</p>
                <p className="team-desc">
                  Ensures timely delivery, quality assurance, and smooth
                  coordination between clients and development teams.
                </p>

                <div className="team-social">
                  <button className="btn btn-link p-0 border-0" style={{ background: "none" }}>
                    <Linkedin />
                  </button>
                  <a href="mailto:info@uiplus.in"><EnvelopeFill /></a>
                </div>
              </Card.Body>
            </Card>
          </Col>
          

          {/* Team Member 2 */}
          <Col md={3}>
            <Card className="team-card">
              <img
                src="/images/personIcon02.png"
                alt="Team Member"
                className="team-img"
              />
              <Card.Body>
                <h5 className="team-name">Neha Sharma</h5>
                <p className="team-role">UI/UX Designer</p>
                <p className="team-desc">
                  Passionate about creating user-centric designs with modern
                  UI/UX principles and accessibility standards.
                </p>

                <div className="team-social">
                  <button className="btn btn-link p-0 border-0" style={{ background: "none" }}>
                    <Linkedin />
                  </button>
                  <a href="mailto:info@uiplus.in"><EnvelopeFill /></a>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Team Member 3 */}
          <Col md={3}>
            <Card className="team-card">
              <img
                src="/images/personIcon02.png"
                alt="Team Member"
                className="team-img"
              />
              <Card.Body>
                <h5 className="team-name">Amit Deshmukh</h5>
                <p className="team-role">Senior Software Engineer</p>
                <p className="team-desc">
                  Expertise in full-stack development with React and ASP.NET,
                  delivering scalable enterprise solutions.
                </p>

                <div className="team-social">
                  <button className="btn btn-link p-0 border-0" style={{ background: "none" }}>
                    <Linkedin />
                  </button>
                  <a href="mailto:info@uiplus.in"><EnvelopeFill /></a>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Team Member 4 */}
          <Col md={3}>
            <Card className="team-card">
              <img
                src="/images/personIcon02.png"
                alt="Team Member"
                className="team-img"
              />
              <Card.Body>
                <h5 className="team-name">Rahul Patil</h5>
                <p className="team-role">Project Manager</p>
                <p className="team-desc">
                  Ensures timely delivery, quality assurance, and smooth
                  coordination between clients and development teams.
                </p>

                <div className="team-social">
                  <button className="btn btn-link p-0 border-0" style={{ background: "none" }}>
                    <Linkedin />
                  </button>
                  <a href="mailto:info@uiplus.in"><EnvelopeFill /></a>
                </div>
              </Card.Body>
            </Card>
          </Col>

        </Row>

      </Container>
    </section>
  );
}

export default TeamMember;
